// @flow
import * as React from 'react'
import type { Gathering, School } from 'types'
import { schoolVanityUrl } from 'urls'
import { P, H4 } from 'ui/Typography'
import Link from 'ui/Link'
import Markdown from 'ui/Markdown'
import Section from 'ui/Section'

type Props = {
  gathering: Gathering,
  school: School,
}

const lego = window.lego

export default class GatheringPageContent extends React.Component<Props> {
  render = () => {
    return (
      <React.Fragment>
        <Section>
          <P>
            <Markdown value={this.props.gathering.description} />
          </P>
          {this.renderPhotoMaybe(this.gatheringPhoto)}
        </Section>
        {this.renderSchoolInfoMaybe()}
      </React.Fragment>
    )
  }

  renderSchoolInfoMaybe = () => {
    if (!this.props.gathering.schoolSynopsis) return null

    return (
      <Section>
        <P>
          <H4>About {this.props.school.name}</H4>
        </P>
        {this.renderPhotoMaybe(this.props.gathering.schoolPhoto)}
        <Markdown value={this.props.gathering.schoolSynopsis} />
        <P>
          <Link href={schoolVanityUrl(this.props.school)}>Learn more about our school</Link>
        </P>
      </Section>
    )
  }

  renderPhotoMaybe = (photo: ?string) => {
    if (!photo) return null

    return (
      <P>
        <img className="GatheringPage-image" src={photo} role="presentation" />
      </P>
    )
  }

  get gatheringPhoto(): string {
    if (!this.props.gathering.photos || !this.props.gathering.photos.length) {
      return `${lego.config.ASSET_DOMAIN}/images/school/school-profile-top.jpg`
    }

    return this.props.gathering.photos[0]
  }
}
